<template>
  <div id="itf-list-grid" class="w-100">
    <b-row class="pageContent">
      <b-col class="filtersContainer" md="12">
        <div class="filters">
          <div class="filter-column">
            <b-form-input
              v-model="filters.search"
              autocomplete="off"
              placeholder="Փնտրել"
              class="w-full text-uppercase opinionFilter"
              @change="reloadFromStart"
            />
          </div>

          <div class="filter-column">
            <b-form-input
              v-model="filters.certificateNo"
              autocomplete="off"
              placeholder="Վկայական №"
              class="w-full opinionFilter certificateNoFilter"
              @change="reloadFromStart"
            />
          </div>

          <div v-if="showCompanyFilter" class="filter-column">
            <v-select
              v-model="filters.company"
              placeholder="Կազմակերպություն"
              :reduce="prefix => prefix.id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="companies"
              class="companyFilterSelect"
              @input="reloadFromStart"
            />
          </div>
        </div>
      </b-col>

      <b-col class="tableContainer">
        <ag-grid-vue
          ref="agGridTable"
          :localeText="localization"
          :components="components"
          :gridOptions="gridOptions"
          :class="tableClass"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="items"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="perPage"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
          @gridReady="onGridReady"
        />

        <b-card-body class="d-flex justify-content-between flex-wrap pt-0 pb-0 align-items-center">
          <strong class="black">
            {{ totalRows }} արդյունք
          </strong>
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
              @input="changePage"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCardBody, BCol, BFormInput, BPagination, BRow } from 'bootstrap-vue'
import { AgGridVue } from 'ag-grid-vue'
import vSelect from 'vue-select'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css'
import AG_GRID_LOCALE_HY from '@core/global/ag-grid-hy'
import store from '@/store'
import itfModule from '@/store/itf/itf'
import techServiceModule from '@/store/tech-service/techServiceModule'
import companyModule from '@/store/companies/companyModule'
import CellRendererItfActions from '@/views/pages/itf/columns/CellRendererItfActions.vue'
import CellRendererAttachment from '@/views/pages/tech-service/columns/CellRendererAttachment.vue'
import CellRendererCarRegNo from '@/views/pages/tech-service/columns/CellRendererCarRegNo.vue'

export default {
  name: 'ItfListGrid',
  components: {
    AgGridVue,
    BCardBody,
    BCol,
    BFormInput,
    BPagination,
    BRow,
    vSelect,
    CellRendererItfActions,
    CellRendererAttachment,
    CellRendererCarRegNo,
  },
  props: {
    actionName: {
      type: String,
      default: 'getItfs',
    },
    showCompany: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      ITF_STORE_MODULE_NAME: 'itfModule',
      TECH_SERVICE_STORE_MODULE_NAME: 'techServiceModule',
      COMPANIES_STORE_MODULE_NAME: 'companiesModule',
      localization: AG_GRID_LOCALE_HY,
      currentPage: 1,
      filters: {
        search: '',
        certificateNo: '',
        company: null,
      },
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        filter: true,
      },
      components: {
        CellRendererItfActions,
        CellRendererAttachment,
        CellRendererCarRegNo,
      },
    }
  },
  computed: {
    items() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].itfs
    },
    totalRows() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].pagination.total || this.items.length
    },
    userType() {
      try {
        return atob(this.$store.state.user_type)
      } catch (e) {
        return null
      }
    },
    isAdminOrViewer() {
      return this.userType === 'ADMIN' || this.userType === 'VIEWER'
    },
    isOperator() {
      return this.userType === 'TECHNICAL_SERVICE_OPERATOR'
    },
    showCompanyFilter() {
      return this.showCompany && this.isAdminOrViewer
    },
    company() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].company
        || (this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME]
          && this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME].company)
        || null
    },
    companies() {
      const companies = [...(this.$store.state[this.COMPANIES_STORE_MODULE_NAME].companies || [])]
        .filter(c => c.universal)
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))

      const mapped = companies.map(e => ({
        label: e.name,
        id: e._id,
      }))

      return [
        {
          label: 'Կազմակերպություն',
          id: null,
          disabled: true,
        },
        ...mapped,
      ]
    },
    showCameraColumn() {
      if (this.isAdminOrViewer) return true
      if (this.userType === 'TECHNICAL_SERVICE_OWNER') return true
      if (this.isOperator) return !!(this.company && this.company.camera)
      return true
    },
    cameraColumnWidth() {
      return this.isAdminOrViewer ? 170 : 65
    },
    user() {
      return this.$store.state.user || {}
    },
    isAdminEditor() {
      const emails = ['ruben.ordanyan@gmail.com', 'khamazaspyan@gmail.com']
      return this.userType === 'ADMIN' && emails.includes(this.user.email)
    },
    // edit + delete + print → 3 icons; print only → 1 icon
    actionsColumnWidth() {
      if (this.isAdminEditor) return 130
      return 55
    },
    dateRange() {
      const moduleState = this.$store.state[this.TECH_SERVICE_STORE_MODULE_NAME]
      if (moduleState && moduleState.dateRange) {
        return moduleState.dateRange
      }
      const start = new Date()
      start.setHours(0, 0, 0, 0)
      const end = new Date()
      end.setHours(23, 59, 59, 59)
      return { startDate: start, endDate: end }
    },
    isDark() {
      return this.$store.state.appConfig && this.$store.state.appConfig.layout.skin === 'dark'
    },
    tableClass() {
      return this.isDark
        ? 'tech-service-table ag-theme-alpine-dark w-100 ag-grid-table'
        : 'tech-service-table ag-theme-alpine w-100 ag-grid-table'
    },
    columnDefs() {
      const cols = [
        {
          headerName: '#',
          field: 'createdAt',
          width: this.actionsColumnWidth,
          minWidth: this.actionsColumnWidth,
          maxWidth: this.actionsColumnWidth,
          filter: false,
          suppressSizeToFit: true,
          cellRendererFramework: 'CellRendererItfActions',
        },
        {
          headerName: 'Ամսաթիվ',
          field: 'createdAt',
          width: 170,
          valueFormatter: this.dateFormatter,
        },
        {
          headerName: 'Վկայական №',
          field: 'certificateNo',
          width: 120,
        },
      ]

      if (this.showCameraColumn) {
        cols.push({
          headerName: '📷',
          field: 'camera',
          filter: false,
          width: this.cameraColumnWidth,
          cellRendererFramework: 'CellRendererAttachment',
        })
      }

      cols.push(
        {
          headerName: 'Համարանիշ',
          field: 'CarRegNo',
          width: 160,
          cellRendererFramework: 'CellRendererCarRegNo',
        },
      )

      if (this.showCompany) {
        cols.push({
          headerName: 'Կազմակերպություն',
          field: 'company',
          width: 180,
          valueFormatter: params => (params.value && params.value.name) || '',
        })
      }

      cols.push(
        {
          headerName: 'Օպերատոր',
          field: 'createdBy',
          width: 150,
          valueFormatter: this.createdByFormatter,
        },
        {
          headerName: 'Տնօրինող',
          field: 'Owner',
          width: 180,
        },
        {
          headerName: 'Մակնիշ',
          field: 'car',
          width: 130,
        },
        {
          headerName: 'Մոդել',
          field: 'car_model',
          width: 150,
        },
        {
          headerName: 'Խումբ',
          field: 'car_group',
          width: 150,
        },
        {
          headerName: 'Տիպ',
          field: 'car_type',
          width: 160,
        },
        {
          headerName: 'Փաստաթուղթ',
          field: 'documentNumber',
          width: 140,
        },
        {
          headerName: 'VIN',
          field: 'VIN',
          width: 180,
        },
        {
          headerName: 'Շարժիչ',
          field: 'EngineNo',
          width: 120,
        },
        {
          headerName: 'Շարժիչի տեսակ',
          field: 'engine_type_id',
          width: 150,
          valueFormatter: this.engineTypeFormatter,
        },
        {
          headerName: 'Վառելիք',
          field: 'fuel',
          width: 130,
          valueFormatter: params => params.value || (params.data && params.data.fuel_name) || '',
        },
        {
          headerName: 'Թողարկում',
          field: 'MadeAt',
          width: 110,
        },
        {
          headerName: 'Հեռախոս',
          field: 'Phone',
          width: 140,
        },
        {
          headerName: 'Հաջորդ ՏԶ',
          field: 'NextCheckup',
          width: 120,
          valueFormatter: this.nextCheckupFormatter,
        },
        {
          headerName: 'Քաշ',
          field: 'weight',
          width: 100,
        },
        {
          headerName: 'Առավել. քաշ',
          field: 'max_weight',
          width: 120,
        },
        {
          headerName: 'Reg No',
          field: 'reg_num',
          width: 130,
        },
      )

      return cols
    },
  },
  created() {
    if (!store.hasModule(this.ITF_STORE_MODULE_NAME)) {
      store.registerModule(this.ITF_STORE_MODULE_NAME, itfModule)
    }
    if (!store.hasModule(this.TECH_SERVICE_STORE_MODULE_NAME)) {
      store.registerModule(this.TECH_SERVICE_STORE_MODULE_NAME, techServiceModule)
    }
    if (!store.hasModule(this.COMPANIES_STORE_MODULE_NAME)) {
      store.registerModule(this.COMPANIES_STORE_MODULE_NAME, companyModule)
    }
    if (this.isOperator && !this.company) {
      this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/getCompany`).catch(() => {})
    }
    if (this.showCompanyFilter) {
      this.getCompanies()
    }
    this.reload()
    this.$root.$on('itf-date-range-changed', this.onDateRangeChanged)
  },
  beforeDestroy() {
    this.$root.$off('itf-date-range-changed', this.onDateRangeChanged)
  },
  methods: {
    onGridReady() {},
    getCompanies() {
      const action = this.userType === 'VIEWER' ? 'getViewerCompanies' : 'getCompanies'
      this.$store.dispatch(`${this.COMPANIES_STORE_MODULE_NAME}/${action}`).catch(() => {})
    },
    dateFormatter(params) {
      if (!params.value) return ''
      return new Date(params.value).toLocaleString('hy-AM')
    },
    createdByFormatter(params) {
      const user = params.value
      if (!user) return ''
      if (typeof user === 'object') {
        return [user.name, user.lastName].filter(Boolean).join(' ')
      }
      return user
    },
    engineTypeFormatter(params) {
      const value = params.value
      if (!value) return ''
      if (typeof value === 'object') return value.name || value.nameEn || ''
      return value
    },
    nextCheckupFormatter(params) {
      switch (Number(params.value)) {
        case 0: return '6 ամսից'
        case 1: return '1 տարուց'
        case 2: return '2 տարուց'
        default: return params.value == null ? '' : params.value
      }
    },
    buildQuery() {
      const query = {
        search: this.filters.search || '',
        current_page: this.currentPage,
        limit: this.perPage,
      }
      if (this.filters.certificateNo) {
        query.certificateNo = String(this.filters.certificateNo).trim()
      }
      if (this.filters.company) {
        query.company = this.filters.company
      }

      const start = this.dateRange.startDate ? new Date(this.dateRange.startDate) : null
      const end = this.dateRange.endDate ? new Date(this.dateRange.endDate) : null
      if (start && end) {
        start.setHours(0, 0, 0, 0)
        end.setHours(23, 59, 59, 59)
        query.startDate = start.toISOString()
        query.endDate = end.toISOString()
      }

      return query
    },
    reload() {
      this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/${this.actionName}`, this.buildQuery())
    },
    reloadFromStart() {
      this.currentPage = 1
      this.reload()
    },
    changePage(page) {
      this.currentPage = page
      this.reload()
    },
    onDateRangeChanged() {
      this.reloadFromStart()
    },
  },
}
</script>

<style lang="scss">
#itf-list-grid {
  padding-left: 1rem;
  padding-right: 1rem;

  .pageContent {
    margin-left: 0;
    margin-right: 0;
  }

  .filtersContainer,
  .tableContainer {
    padding-left: 0;
    padding-right: 0;
  }

  .filtersContainer {
    .filters {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
      align-items: stretch;
    }

    .filter-column {
      min-height: 38px;
    }

    .companyFilterSelect {
      min-width: 220px;
    }

    .certificateNoFilter {
      min-width: 140px;
      max-width: 180px;
    }
  }

  .tableContainer {
    padding-bottom: 0.5rem;
  }

  .ag-grid-table {
    height: calc(var(--vh, 1vh) * 100 - 17rem);
    padding-top: 0.5rem;
  }
}
</style>
